"use strict";

require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.object.from-entries.js");
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
var __export = (target, all) => {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from)) if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
      get: () => from[key],
      enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
// If the importer is in node compatibility mode or this is not an ESM
// file that has been converted to a CommonJS file using a Babel-
// compatible transform (i.e. "__esModule" has not been set), then set
// "default" to the CommonJS "module.exports" for node compatibility.
isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
  value: mod,
  enumerable: true
}) : target, mod));
var __toCommonJS = mod => __copyProps(__defProp({}, "__esModule", {
  value: true
}), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  AddLineItemHelper: () => AddLineItemHelper,
  CartChangeAfterLogin: () => CartChangeAfterLogin,
  calculateCustomLineItemsOfType: () => calculateCustomLineItemsOfType,
  calculateProductTotals: () => calculateProductTotals,
  cartOrOrderTotals: () => cartOrOrderTotals,
  filterRemainingOption: () => filterRemainingOption,
  getAllMainGroupedLineItems: () => getAllMainGroupedLineItems,
  getBasePrice: () => getBasePrice,
  getCartChangeAfterLogin: () => getCartChangeAfterLogin,
  getCustomLineItemsOfType: () => getCustomLineItemsOfType,
  getDeliveryOptionId: () => getDeliveryOptionId,
  getDiscounts: () => getDiscounts,
  getGroupId: () => getGroupId,
  getGroupedLineItems: () => getGroupedLineItems,
  getLastUpdatedPayment: () => getLastUpdatedPayment,
  getLineItemById: () => getLineItemById,
  getLineItemGroupType: () => getLineItemGroupType,
  getLineItemQuantity: () => getLineItemQuantity,
  getLineItemReviewGroup: () => getLineItemReviewGroup,
  getLineItemsInReviewGroup: () => getLineItemsInReviewGroup,
  getLineItemsIncludingGroupSiblings: () => getLineItemsIncludingGroupSiblings,
  getMainLineItems: () => getMainLineItems,
  getMultipleDesignsGroupLineItems: () => getMultipleDesignsGroupLineItems,
  getOrchestrationLineItems: () => getOrchestrationLineItems,
  getPrice: () => getPrice,
  getReviewGroupLineItems: () => getReviewGroupLineItems,
  getVisibleCartChangeAfterLogin: () => getVisibleCartChangeAfterLogin,
  hasLineItemReviewGroup: () => hasLineItemReviewGroup,
  isAddressOnCartComplete: () => isAddressOnCartComplete,
  isBillingAddressCountryValidOnCart: () => isBillingAddressCountryValidOnCart,
  isBillingAddressValidOnCart: () => isBillingAddressValidOnCart,
  isCart: () => isCart,
  isGroupedLineItem: () => isGroupedLineItem,
  isLineItemReviewGroupLead: () => isLineItemReviewGroupLead,
  isOrder: () => isOrder,
  isShippingAddressCountryValidOnCart: () => isShippingAddressCountryValidOnCart,
  isShippingAddressValidOnCart: () => isShippingAddressValidOnCart,
  lineItemPrices: () => lineItemPrices,
  shouldRemoveArtwork: () => shouldRemoveArtwork,
  transformCartForValidation: () => transformCartForValidation,
  validateCart: () => validateCart
});
module.exports = __toCommonJS(src_exports);

// src/helpers/LineItemHelpers.ts
var getLineItemQuantity = lineItem => lineItem.totalGroupQuantity || lineItem.quantity;
var getLineItemReviewGroup = lineItem => {
  var _a, _b;
  return (_b = (_a = lineItem.custom) == null ? void 0 : _a.fields) == null ? void 0 : _b.reviewGroup;
};
var getLineItemsInReviewGroup = (cart, groupId) => {
  if (!("lineItems" in cart)) {
    return [];
  }
  return cart.lineItems.filter(lineItem => getLineItemReviewGroup(lineItem) === groupId);
};
var isGroupedLineItem = lineItem => {
  var _a, _b, _c;
  if (((_a = lineItem.custom) == null ? void 0 : _a.fields.orchestrationId) !== void 0) {
    return true;
  }
  if (((_b = lineItem.custom) == null ? void 0 : _b.fields.multipleDesignsGroup) !== void 0) {
    return true;
  }
  return ((_c = lineItem.custom) == null ? void 0 : _c.fields.reviewGroup) !== void 0;
};
var getGroupId = lineItem => {
  var _a, _b, _c;
  return {
    orchestrationId: (_a = lineItem.custom) == null ? void 0 : _a.fields.orchestrationId,
    reviewGroup: (_b = lineItem.custom) == null ? void 0 : _b.fields.reviewGroup,
    multipleDesignsGroup: (_c = lineItem.custom) == null ? void 0 : _c.fields.multipleDesignsGroup
  };
};
var getMultipleDesignsGroupLineItems = _ref => {
  let {
    multipleDesignsGroup,
    cartOrOrder
  } = _ref;
  return cartOrOrder.lineItems.filter(lineItem => {
    var _a;
    return ((_a = lineItem.custom) == null ? void 0 : _a.fields.multipleDesignsGroup) === multipleDesignsGroup;
  });
};
var getOrchestrationLineItems = _ref2 => {
  let {
    orchestrationId,
    cartOrOrder
  } = _ref2;
  return cartOrOrder.lineItems.filter(lineItem => {
    var _a;
    return ((_a = lineItem.custom) == null ? void 0 : _a.fields.orchestrationId) === orchestrationId;
  });
};
var getReviewGroupLineItems = _ref3 => {
  let {
    reviewGroup,
    cartOrOrder
  } = _ref3;
  return cartOrOrder.lineItems.filter(lineItem => {
    var _a;
    return ((_a = lineItem.custom) == null ? void 0 : _a.fields.reviewGroup) === reviewGroup;
  });
};
var getLineItemById = _ref4 => {
  let {
    lineItemId,
    cartOrOrder
  } = _ref4;
  return cartOrOrder.lineItems.find(lineItem => lineItem.id === lineItemId);
};
var getGroupedLineItems = _ref5 => {
  let {
    lineItemId,
    cartOrOrder
  } = _ref5;
  const lineItems = [];
  const firstLineItem = getLineItemById({
    lineItemId,
    cartOrOrder
  });
  if (!firstLineItem) {
    throw Error("Line item ".concat(lineItemId, " not found in cart or order ").concat(cartOrOrder.id));
  }
  if (!isGroupedLineItem(firstLineItem)) {
    return lineItems;
  }
  const {
    orchestrationId,
    reviewGroup,
    multipleDesignsGroup
  } = getGroupId(firstLineItem);
  if (orchestrationId) {
    return getOrchestrationLineItems({
      orchestrationId,
      cartOrOrder
    });
  }
  if (multipleDesignsGroup) {
    return getMultipleDesignsGroupLineItems({
      multipleDesignsGroup,
      cartOrOrder
    });
  }
  return getReviewGroupLineItems({
    reviewGroup,
    cartOrOrder
  });
};
var isLineItemOrchestrationLead = lineItem => {
  var _a, _b;
  return Boolean(((_a = lineItem.custom) == null ? void 0 : _a.fields.orchestration) && ((_b = lineItem.custom) == null ? void 0 : _b.fields.recipient) === "customer");
};
var isLineItemReviewGroupLead = lineItem => {
  var _a;
  return Boolean((_a = lineItem.custom) == null ? void 0 : _a.fields.isReviewGroupLead);
};
var isLineItemGroupLead = lineItem => isLineItemReviewGroupLead(lineItem) || isLineItemOrchestrationLead(lineItem);
var getLineItemGroupType = lineItem => {
  var _a, _b;
  const reviewGroup = (_a = lineItem.custom) == null ? void 0 : _a.fields.reviewGroup;
  const multipleDesignsGroup = (_b = lineItem.custom) == null ? void 0 : _b.fields.multipleDesignsGroup;
  if (reviewGroup) {
    return "textile";
  }
  if (multipleDesignsGroup) {
    return "multipleDesigns";
  }
  return void 0;
};
var getAllMainGroupedLineItems = _ref6 => {
  let {
    cartOrOrder
  } = _ref6;
  const seenMultipleDesignsGroups = /* @__PURE__ */new Set();
  return cartOrOrder.lineItems.filter(lineItem => {
    var _a, _b;
    if (!isGroupedLineItem(lineItem)) {
      return true;
    }
    if (isLineItemOrchestrationLead(lineItem)) {
      return true;
    }
    if (isLineItemGroupLead(lineItem)) {
      return true;
    }
    if (getLineItemGroupType(lineItem) === "multipleDesigns") {
      if (seenMultipleDesignsGroups.has((_a = lineItem.custom) == null ? void 0 : _a.fields.multipleDesignsGroup)) {
        return false;
      }
      seenMultipleDesignsGroups.add((_b = lineItem.custom) == null ? void 0 : _b.fields.multipleDesignsGroup);
      return true;
    }
    return false;
  });
};
var hasLineItemReviewGroup = lineItem => {
  var _a, _b;
  return Boolean((_b = (_a = lineItem.custom) == null ? void 0 : _a.fields) == null ? void 0 : _b.reviewGroup);
};

// src/helpers/CartHelpers.ts
var getMainLineItems = cart => {
  if (!("lineItems" in cart)) {
    return [];
  }
  const filteredLineItems = cart.lineItems.filter(lineItem => !hasLineItemReviewGroup(lineItem) || isLineItemReviewGroupLead(lineItem));
  const seenMultipleDesignsGroups = /* @__PURE__ */new Set();
  return filteredLineItems.filter(lineItem => {
    var _a, _b;
    const multipleDesignsGroup = (_b = (_a = lineItem.custom) == null ? void 0 : _a.fields) == null ? void 0 : _b.multipleDesignsGroup;
    if (!multipleDesignsGroup) {
      return true;
    }
    if (seenMultipleDesignsGroups.has(multipleDesignsGroup)) {
      return false;
    }
    seenMultipleDesignsGroups.add(multipleDesignsGroup);
    return true;
  });
};
var getLineItemsIncludingGroupSiblings = cart => {
  if (!("lineItems" in cart)) {
    return [];
  }
  return cart.lineItems;
};
var CartChangeAfterLogin = /* @__PURE__ */(CartChangeAfterLogin2 => {
  CartChangeAfterLogin2["none"] = "none";
  CartChangeAfterLogin2["retrievedCart"] = "retrievedCart";
  CartChangeAfterLogin2["mergedCart"] = "mergedCart";
  return CartChangeAfterLogin2;
})(CartChangeAfterLogin || {});
var getCartChangeAfterLogin = (cartBeforeLogin, cartAfterLogin) => {
  const didCartChange = cartAfterLogin && cartAfterLogin.id !== (cartBeforeLogin == null ? void 0 : cartBeforeLogin.id);
  if (didCartChange) {
    if (!cartBeforeLogin) {
      return "retrievedCart" /* retrievedCart */;
    }
    return "mergedCart" /* mergedCart */;
  }
  return "none" /* none */;
};
var getVisibleCartChangeAfterLogin = (cartBeforeLogin, cartAfterLogin) => {
  const didCartChange = cartAfterLogin && cartAfterLogin.id !== (cartBeforeLogin == null ? void 0 : cartBeforeLogin.id);
  const mainLineItemsBeforeLogin = cartBeforeLogin ? getMainLineItems(cartBeforeLogin) : [];
  const mainLineItemsAfterLogin = cartAfterLogin ? getMainLineItems(cartAfterLogin) : [];
  if (didCartChange && mainLineItemsAfterLogin.length) {
    if (!cartBeforeLogin) {
      return "retrievedCart" /* retrievedCart */;
    }
    if (mainLineItemsBeforeLogin && mainLineItemsAfterLogin.length > mainLineItemsBeforeLogin.length) {
      return "mergedCart" /* mergedCart */;
    }
  }
  return "none" /* none */;
};

// src/helpers/CustomLineItemHelper.ts
var getCustomLineItemsOfType = _ref7 => {
  let {
    cartOrOrder,
    customLineItemType,
    lineItemIds = []
  } = _ref7;
  return cartOrOrder.customLineItems.filter(customLineItem => {
    var _a;
    return ((_a = customLineItem.custom) == null ? void 0 : _a.fields.lineItemType) === customLineItemType;
  }).filter(customLineItem => {
    var _a;
    if (!lineItemIds.length) {
      return true;
    }
    return ((_a = customLineItem.custom) == null ? void 0 : _a.fields.lineItemReference) && lineItemIds.includes(customLineItem.custom.fields.lineItemReference);
  });
};
var getDeliveryOptionId = (customLineItems, lineItemId) => {
  var _a;
  const customLinesItems = customLineItems.find(item => {
    var _a2, _b;
    return ((_a2 = item.custom) == null ? void 0 : _a2.fields.lineItemType) === "shipping" && ((_b = item.custom) == null ? void 0 : _b.fields.lineItemReference) === lineItemId;
  });
  return (_a = customLinesItems == null ? void 0 : customLinesItems.custom) == null ? void 0 : _a.fields.eCommerceDeliveryOptionId;
};

// src/helpers/ValidationHelpers.ts
var import_business_logic = require("@printdeal/business-logic");
var import_transformers = require("@printdeal/transformers");
var import_json = require("klona/json");
function isAddressOnCartComplete(address2) {
  return Boolean(address2 && address2.firstName && address2.lastName && address2.streetName && address2.streetNumber && address2.postalCode && address2.city && address2.country);
}
var isShippingAddressValidOnCart = cart => {
  var _a;
  if (!((_a = cart.shippingAddress) == null ? void 0 : _a.country)) {
    return false;
  }
  return Boolean(getMainLineItems(cart).filter(lineItem => !(0, import_business_logic.hasPickupPoint)(lineItem)).find(lineItem => {
    var _a2, _b, _c;
    return (
      // Empty shipping address array = invalid
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      !((_c = (_b = (_a2 = lineItem.custom) == null ? void 0 : _a2.fields) == null ? void 0 : _b.shippingAddressPerLineItem) == null ? void 0 : _c.length) || lineItem.custom.fields.shippingAddressPerLineItem.find(address2 => {
        const parsedAddress = (0, import_transformers.keyValueObjectToStringArray)(address2);
        return !isAddressOnCartComplete(parsedAddress);
      })
    );
  })) === false;
};
var isShippingAddressCountryValidOnCart = (cart, validCountries) => {
  if (!cart.shippingAddress) {
    return false;
  }
  if (!validCountries.includes(cart.shippingAddress.country)) {
    return false;
  }
  return Boolean(getMainLineItems(cart).filter(lineItem => !(0, import_business_logic.hasPickupPoint)(lineItem)).find(
  // We can assume this custom field exists here, as `isShippingAddressValidOnCart()`
  // already validated that above.
  lineItem => lineItem.custom.fields.shippingAddressPerLineItem.find(address2 => {
    const parsedAddress = (0, import_transformers.keyValueObjectToStringArray)(address2);
    return !validCountries.includes(parsedAddress.country);
  }))) === false;
};
var isBillingAddressValidOnCart = cart => {
  if (!cart.billingAddress) {
    return false;
  }
  if (!cart.billingAddress.email) {
    return false;
  }
  return isAddressOnCartComplete(cart.billingAddress);
};
var isBillingAddressCountryValidOnCart = (cart, validCountries) => {
  if (!cart.billingAddress) {
    return false;
  }
  return validCountries.includes(cart.billingAddress.country);
};
var transformShippingAddresses = _ref8 => {
  let {
    lineItems
  } = _ref8;
  if (!lineItems) {
    return [];
  }
  return lineItems.map(lineItem => {
    var _a, _b;
    if ((_b = (_a = lineItem == null ? void 0 : lineItem.custom) == null ? void 0 : _a.fields) == null ? void 0 : _b.shippingAddressPerLineItem) {
      const {
        shippingAddressPerLineItem
      } = lineItem.custom.fields;
      return __spreadProps(__spreadValues({}, lineItem), {
        custom: __spreadProps(__spreadValues({}, lineItem.custom), {
          fields: __spreadProps(__spreadValues({}, lineItem.custom.fields), {
            // @ts-expect-error
            shippingAddressPerLineItem: (0, import_transformers.arrayOfStringArraysToArrayOfObjects)(shippingAddressPerLineItem)
          })
        })
      });
    }
    return lineItem;
  });
};
var transformCartForValidation = cart => {
  var _a, _b;
  const transformedCart = (0, import_json.klona)(cart);
  if (((_b = (_a = cart == null ? void 0 : cart.custom) == null ? void 0 : _a.fields) == null ? void 0 : _b.isCompany) === true) {
    if (transformedCart.shippingAddress) {
      transformedCart.shippingAddress = __spreadProps(__spreadValues({}, transformedCart.shippingAddress), {
        isCompany: true
      });
    }
    if (transformedCart.billingAddress) {
      transformedCart.billingAddress = __spreadProps(__spreadValues({}, transformedCart.billingAddress), {
        isCompany: true
      });
    }
  }
  transformedCart.lineItems = transformShippingAddresses(transformedCart);
  return transformedCart;
};

// src/helpers/PaymentHelpers.ts
var getLastUpdatedPayment = cartOrOrder => {
  var _a, _b;
  if (!((_a = cartOrOrder.paymentInfo) == null ? void 0 : _a.payments.length)) {
    return void 0;
  }
  const sortedPayments = [...cartOrOrder.paymentInfo.payments].sort((a, b) => {
    var _a2, _b2, _c, _d;
    const aDate = new Date((_b2 = (_a2 = a.obj) == null ? void 0 : _a2.lastModifiedAt) != null ? _b2 : "");
    const bDate = new Date((_d = (_c = b.obj) == null ? void 0 : _c.lastModifiedAt) != null ? _d : "");
    return bDate.getTime() - aDate.getTime();
  });
  return (_b = sortedPayments.shift()) == null ? void 0 : _b.obj;
};

// src/helpers/AddLineItemHelper.ts
var import_business_logic2 = require("@printdeal/business-logic");
var import_transformers2 = require("@printdeal/transformers");
var AddLineItemHelper = class _AddLineItemHelper {
  static buildLineItemShape(props) {
    var _c;
    const {
        userSelection: _a
      } = props,
      _b = _a,
      {
        Quantity: quantity
      } = _b,
      userSelection = __objRest(_b, ["Quantity"]);
    if (!props.productVersion && !props.variantSku || props.productVersion && props.variantSku) {
      throw new Error("Either 'productVersion' or 'variantSku' must be provided, not both.");
    }
    return __spreadValues(__spreadProps(__spreadValues(__spreadProps(__spreadValues({
      quantity: (_c = props.quantity) != null ? _c : Number(quantity),
      product: __spreadProps(__spreadValues(__spreadValues({
        productId: props.productId,
        productKey: props.productKey
      }, props.productVersion && {
        productVersion: props.productVersion
      }), props.variantSku && {
        variantSku: props.variantSku
      }), {
        userSelection
      })
    }, props.deliveryOptionId && {
      shipping: {
        deliveryOptionId: props.deliveryOptionId
      }
    }), {
      services: props.services,
      reorderOriginalLineItemNumber: props.reorderOriginalLineItemNumber,
      files: __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, (props.documentReferenceUrl || props.mcpDocumentsSource) && {
        mcp: {
          mcpDocumentsSource: props.documentReferenceUrl ? ["DocumentReferenceUrl:".concat(props.documentReferenceUrl)] : props.mcpDocumentsSource
        }
      }), (props.manufacturingReadyDocumentUrl || props.mrdMetadata) && {
        manufacturingReadyDocument: {
          url: props.manufacturingReadyDocumentUrl,
          metadata: props.mrdMetadata
        }
      }), (props.userUploadsUrl || props.userUploadComplete) && {
        userUploads: {
          url: props.userUploadsUrl,
          complete: props.userUploadComplete
        }
      }), {
        editorType: props.editorType
      })
    }), (props.skipReview || props.groupId || props.isGroupLead) && {
      review: {
        skip: props.skipReview,
        group: {
          id: props.groupId,
          isLead: props.isGroupLead
        }
      }
    }), {
      fulfillmentGroupId: props.fulfillmentGroupId,
      multipleDesignsGroup: props.multipleDesignsGroup
    }), props.orchestration && {
      orchestration: props.orchestration
    });
  }
  static buildLineItemsFromExistingLineItems(_ref9) {
    let {
      orderOrCart,
      lineItems,
      isReorder = false,
      isWithFile = false,
      artworks
    } = _ref9;
    return {
      lineItems: lineItems.map(lineItem => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v;
        const servicesLineItems = (0, import_business_logic2.getLinkedServices)(lineItem.id, orderOrCart);
        const servicesKeys = servicesLineItems.length > 0 ? servicesLineItems.map(serviceLineItem => {
          var _a2;
          return (_a2 = serviceLineItem.custom.fields) == null ? void 0 : _a2.serviceKey;
        }) : void 0;
        const orchestration = ((_a = lineItem.custom) == null ? void 0 : _a.fields.orchestration) ? JSON.parse((_b = lineItem.custom) == null ? void 0 : _b.fields.orchestration) : void 0;
        return _AddLineItemHelper.buildLineItemShape(__spreadValues(__spreadValues(__spreadValues({
          quantity: lineItem.quantity,
          productId: (_c = lineItem.custom) == null ? void 0 : _c.fields.contentfulPageId,
          productKey: (_d = lineItem.custom) == null ? void 0 : _d.fields.productKey,
          userSelection: (0, import_transformers2.keyValueObjectToStringArray)((_e = lineItem.custom) == null ? void 0 : _e.fields.userSelection),
          productVersion: (_f = lineItem.custom) == null ? void 0 : _f.fields.MMProductVersion,
          variantSku: lineItem.variant.sku,
          services: isReorder ? void 0 : servicesKeys,
          groupId: (_g = lineItem.custom) == null ? void 0 : _g.fields.reviewGroup,
          isGroupLead: (_h = lineItem.custom) == null ? void 0 : _h.fields.isReviewGroupLead,
          multipleDesignsGroup: (_i = lineItem.custom) == null ? void 0 : _i.fields.multipleDesignsGroup,
          documentReferenceUrl: (_j = lineItem.custom) == null ? void 0 : _j.fields.documentReferenceUrl,
          skipReview: (_k = lineItem.custom) == null ? void 0 : _k.fields.skipReview,
          fulfillmentGroupId: (_l = lineItem.custom) == null ? void 0 : _l.fields.fulfillmentGroup,
          reorderOriginalLineItemNumber: isReorder ? (_m = lineItem.custom) == null ? void 0 : _m.fields.lineItemNumber : void 0
        }, ((_n = lineItem.custom) == null ? void 0 : _n.fields.productVersion) && {
          shipping: {
            deliveryOptionId: getDeliveryOptionId(orderOrCart.customLineItems, lineItem.id)
          }
        }), _AddLineItemHelper.getFileFields(lineItem, isWithFile, artworks == null ? void 0 : artworks.find(artwork => artwork.lineItemId === lineItem.id))), ((_o = lineItem.custom) == null ? void 0 : _o.fields.orchestrationId) && ((_p = lineItem.custom) == null ? void 0 : _p.fields.orchestration) ? {
          orchestration: {
            id: (_q = lineItem.custom) == null ? void 0 : _q.fields.orchestrationId,
            groupId: (_r = lineItem.custom) == null ? void 0 : _r.fields.serviceGroup,
            recipient: orchestration == null ? void 0 : orchestration.recipient,
            serviceParams: {
              serviceKey: (_s = lineItem.custom) == null ? void 0 : _s.fields.serviceKey,
              serviceLevel: (_t = lineItem.custom) == null ? void 0 : _t.fields.serviceLevel,
              serviceType: (_u = lineItem.custom) == null ? void 0 : _u.fields.serviceType,
              serviceName: (_v = lineItem.custom) == null ? void 0 : _v.fields.serviceName
            },
            itemOrchestration: orchestration == null ? void 0 : orchestration.itemOrchestration
          }
        } : {}));
      })
    };
  }
  static getFileFields(lineItem, withFile, artwork) {
    var _a, _b, _c, _d, _e, _f;
    if (!withFile) {
      return {};
    }
    let additionalFields;
    additionalFields = {
      userUploadsUrl: (_a = lineItem.custom) == null ? void 0 : _a.fields.userUploadsUrl,
      userUploadComplete: (_b = lineItem.custom) == null ? void 0 : _b.fields.userUploadComplete,
      editorType: (_c = lineItem.custom) == null ? void 0 : _c.fields.editorType
    };
    if (((_d = lineItem.custom) == null ? void 0 : _d.fields.manufacturingReadyDocumentUrl) || ((_e = lineItem.custom) == null ? void 0 : _e.fields.mcpDocumentsSource)) {
      additionalFields = __spreadProps(__spreadValues({}, additionalFields), {
        mcpDocumentsSource: artwork == null ? void 0 : artwork.mcpDocumentsSource,
        manufacturingReadyDocumentUrl: lineItem.custom.fields.manufacturingReadyDocumentUrl,
        mrdMetadata: (_f = lineItem.custom) == null ? void 0 : _f.fields.mrdMetadata,
        skipReview: artwork == null ? void 0 : artwork.skipReview
      });
    }
    return additionalFields;
  }
};

// src/helpers/ArtworkHelpers.ts
var import_transformers3 = require("@printdeal/transformers");
var filterRemainingOption = (remainingOptions, newUserSelection) => remainingOptions.filter(option => newUserSelection[option]);
var shouldRemoveArtwork = (lineItem, newUserSelection, remainingOptions) => {
  var _a;
  const userSelection = (0, import_transformers3.keyValueObjectToStringArray)((_a = lineItem.custom) == null ? void 0 : _a.fields.userSelection);
  return !filterRemainingOption(remainingOptions, newUserSelection).every(remainingOption => {
    var _a2, _b;
    if (!newUserSelection[remainingOption]) {
      return false;
    }
    return ((_a2 = userSelection[remainingOption]) == null ? void 0 : _a2.toLowerCase()) === ((_b = newUserSelection[remainingOption]) == null ? void 0 : _b.toLowerCase());
  });
};

// src/helpers/EntityHelper.ts
function isCart(entity) {
  return Boolean("cartState" in entity);
}
function isOrder(entity) {
  return Boolean("orderState" in entity);
}

// src/pricing/Pricing.ts
var import_json2 = require("klona/json");
var getBasePrice = _ref10 => {
  let {
    lineItems
  } = _ref10;
  const [{
    taxedPrice
  }] = lineItems;
  const totalGross = lineItems.reduce((total, _ref11) => {
    let {
      taxRate,
      custom: lineItemCustomField,
      taxedPrice: lineItemTaxedPrice
    } = _ref11;
    var _a;
    const gross = ((_a = lineItemCustomField == null ? void 0 : lineItemCustomField.fields.baseProductPriceValue) == null ? void 0 : _a.centAmount) ? Math.round(lineItemCustomField.fields.baseProductPriceValue.centAmount * (1 + taxRate.amount)) : lineItemTaxedPrice.totalGross.centAmount;
    return total + gross;
  }, 0);
  const totalTax = lineItems.reduce((total, _ref12) => {
    let {
      taxRate,
      taxedPrice: lineItemTaxedPrice,
      custom: lineItemCustomField
    } = _ref12;
    const tax = (lineItemCustomField == null ? void 0 : lineItemCustomField.fields.baseProductPriceValue) ? Math.round(lineItemCustomField.fields.baseProductPriceValue.centAmount * taxRate.amount) : lineItemTaxedPrice.totalTax.centAmount;
    return total + (tax != null ? tax : 0);
  }, 0);
  return {
    totalNet: {
      centAmount: totalGross - totalTax,
      currencyCode: taxedPrice.totalTax.currencyCode
    },
    totalGross: {
      centAmount: totalGross,
      currencyCode: taxedPrice.totalTax.currencyCode
    },
    totalTax: {
      centAmount: totalTax,
      currencyCode: taxedPrice.totalTax.currencyCode
    }
  };
};
var getPrice = _ref13 => {
  let {
    lineItems
  } = _ref13;
  const [{
    taxedPrice,
    taxRate
  }] = lineItems;
  const {
    currencyCode
  } = taxedPrice.totalTax;
  return {
    totalNet: {
      centAmount: lineItems.reduce((total, lineItem) => {
        var _a, _b, _c;
        if ((_a = lineItem.custom) == null ? void 0 : _a.fields.discountedProductPriceValue) {
          const totalNet = Math.round(lineItem.custom.fields.discountedProductPriceValue.centAmount / (1 + taxRate.amount));
          return total + totalNet;
        }
        return total + ((_c = (_b = lineItem.taxedPrice) == null ? void 0 : _b.totalNet.centAmount) != null ? _c : 0);
      }, 0),
      currencyCode
    },
    totalGross: {
      centAmount: lineItems.reduce((total, lineItem) => {
        var _a, _b, _c;
        if ((_a = lineItem.custom) == null ? void 0 : _a.fields.discountedProductPriceValue) {
          return total + lineItem.custom.fields.discountedProductPriceValue.centAmount;
        }
        return total + ((_c = (_b = lineItem.taxedPrice) == null ? void 0 : _b.totalGross.centAmount) != null ? _c : 0);
      }, 0),
      currencyCode
    },
    totalTax: {
      centAmount: lineItems.reduce((total, lineItem) => {
        var _a, _b, _c, _d;
        if ((_a = lineItem.custom) == null ? void 0 : _a.fields.discountedProductPriceValue) {
          const totalNet = Math.round(lineItem.custom.fields.discountedProductPriceValue.centAmount / (1 + taxRate.amount));
          return total + Math.round(lineItem.custom.fields.discountedProductPriceValue.centAmount - totalNet);
        }
        return total + ((_d = (_c = (_b = lineItem.taxedPrice) == null ? void 0 : _b.totalTax) == null ? void 0 : _c.centAmount) != null ? _d : 0);
      }, 0),
      currencyCode
    }
  };
};
var getDiscounts = _ref14 => {
  let {
    lineItems,
    discountTags = []
  } = _ref14;
  const [{
    taxedPrice,
    taxRate
  }] = lineItems;
  const {
    currencyCode
  } = taxedPrice.totalTax;
  const discounts = {};
  discountTags.push("unCategorized");
  let remainingDiscount = 0;
  lineItems.forEach(lineItem => {
    var _a, _b, _c;
    if (!((_a = lineItem.custom) == null ? void 0 : _a.fields.eCommerceDiscounts)) {
      const diff = ((_b = lineItem.custom) == null ? void 0 : _b.fields.discountedProductPriceValue) && ((_c = lineItem.custom) == null ? void 0 : _c.fields.baseProductPriceValue) ? lineItem.custom.fields.discountedProductPriceValue.centAmount - lineItem.custom.fields.baseProductPriceValue.centAmount : 0;
      if (diff === 0) {
        return;
      }
      remainingDiscount += Math.round(diff / (1 + taxRate.amount));
      return;
    }
    const eCommerceDiscounts = JSON.parse(lineItem.custom.fields.eCommerceDiscounts);
    eCommerceDiscounts.forEach(_ref15 => {
      let {
        amount: {
          centAmount
        },
        tags: [firstTag]
      } = _ref15;
      const tax = Math.round(centAmount * ((taxRate == null ? void 0 : taxRate.amount) || 0));
      if (discountTags.includes(firstTag)) {
        if (!discounts[firstTag]) {
          discounts[firstTag] = {
            tag: firstTag,
            totalGross: {
              centAmount: 0,
              currencyCode
            },
            totalNet: {
              centAmount: 0,
              currencyCode
            },
            totalTax: {
              centAmount: 0,
              currencyCode
            }
          };
        }
        discounts[firstTag].totalNet.centAmount += centAmount;
        discounts[firstTag].totalTax.centAmount += tax;
        discounts[firstTag].totalGross.centAmount += centAmount + tax;
      } else {
        remainingDiscount += centAmount;
      }
    });
  });
  if (remainingDiscount > 0) {
    discounts.unCategorized = {
      tag: "unCategorized",
      totalGross: {
        centAmount: 0,
        currencyCode
      },
      totalNet: {
        centAmount: 0,
        currencyCode
      },
      totalTax: {
        centAmount: 0,
        currencyCode
      }
    };
    discounts.unCategorized.totalNet.centAmount += remainingDiscount;
    discounts.unCategorized.totalTax.centAmount += Math.round(remainingDiscount * taxRate.amount);
    discounts.unCategorized.totalGross.centAmount += Math.round(remainingDiscount * (1 + taxRate.amount));
  }
  return Object.keys(discounts).length ? discounts : void 0;
};
var calculateProductTotals = _ref16 => {
  let {
    lineItems,
    discountTags = []
  } = _ref16;
  const [lineItem] = lineItems;
  const price = getPrice({
    lineItems
  });
  const basePrice = getBasePrice({
    lineItems
  });
  return {
    id: lineItem.id,
    sku: "productKey" in lineItem ? lineItem.productKey : void 0,
    taxRate: {
      amount: lineItem.taxRate.amount,
      country: lineItem.taxRate.country
    },
    basePrice,
    price,
    discounts: getDiscounts({
      lineItems,
      discountTags
    }),
    totalDiscount: {
      totalTax: {
        centAmount: basePrice.totalTax.centAmount - price.totalTax.centAmount,
        currencyCode: basePrice.totalTax.currencyCode
      },
      totalNet: {
        centAmount: basePrice.totalNet.centAmount - price.totalNet.centAmount,
        currencyCode: basePrice.totalNet.currencyCode
      },
      totalGross: {
        centAmount: basePrice.totalGross.centAmount - price.totalGross.centAmount,
        currencyCode: basePrice.totalGross.currencyCode
      }
    },
    quantity: lineItem.quantity
  };
};
var calculateCustomLineItemsOfType = _ref17 => {
  let {
    lineItems,
    cartOrOrder,
    discountTags,
    customLineItemType
  } = _ref17;
  const customLineItems = getCustomLineItemsOfType({
    cartOrOrder,
    lineItemIds: lineItems.map(_ref18 => {
      let {
        id
      } = _ref18;
      return id;
    }),
    customLineItemType
  });
  if (!customLineItems.length) {
    return void 0;
  }
  const [customLineItem] = customLineItems;
  return {
    taxRate: customLineItem.taxRate,
    basePrice: getBasePrice({
      lineItems: customLineItems
    }),
    price: getPrice({
      lineItems: customLineItems
    }),
    discounts: getDiscounts({
      lineItems: customLineItems,
      discountTags
    }),
    quantity: customLineItem.quantity
  };
};
var calculateCouponTotals = _ref19 => {
  let {
    cartOrOrder: {
      discountCodes,
      lineItems
    }
  } = _ref19;
  return discountCodes == null ? void 0 : discountCodes.filter(code => code.discountCode.obj).map(discountCode => {
    var _a, _b;
    const code = (_a = discountCode.discountCode.obj) == null ? void 0 : _a.code;
    const discountIds = (_b = discountCode.discountCode.obj) == null ? void 0 : _b.cartDiscounts.map(_ref20 => {
      let {
        id
      } = _ref20;
      return id;
    });
    const totalDiscount = lineItems.filter(lineItem => lineItem.discountedPricePerQuantity.filter(discountedPricePerQuantity => discountedPricePerQuantity.discountedPrice.includedDiscounts.filter(includedDiscount => discountIds == null ? void 0 : discountIds.includes(includedDiscount.discount.id)))).reduce((prevLineItem, lineItem) => {
      const discount = lineItem.discountedPricePerQuantity.reduce((prevDiscountedPricePerQuantity, discountedPricePerQuantity) => {
        const totalDiscountedPricePerQuantity = discountedPricePerQuantity.discountedPrice.includedDiscounts.reduce((prevIncludedDiscount, includedDiscounts) => {
          if (!(discountIds == null ? void 0 : discountIds.includes(includedDiscounts.discount.id))) {
            return prevIncludedDiscount;
          }
          const {
            preciseAmount
          } = includedDiscounts.discountedAmount;
          return Math.round(preciseAmount * discountedPricePerQuantity.quantity / __pow(10, 5)) + prevIncludedDiscount;
        }, 0);
        return prevDiscountedPricePerQuantity + totalDiscountedPricePerQuantity;
      }, 0);
      return prevLineItem + discount;
    }, 0);
    return {
      centAmount: totalDiscount,
      currencyCode: "EUR",
      code
    };
  }).filter(Boolean);
};
var calculateServiceTotals = _ref21 => {
  let {
    lineItems,
    cartOrOrder,
    discountTags
  } = _ref21;
  return getCustomLineItemsOfType({
    cartOrOrder,
    lineItemIds: lineItems.map(_ref22 => {
      let {
        id
      } = _ref22;
      return id;
    }),
    customLineItemType: "service"
  }).map(serviceCustomLineItem => {
    var _a, _b;
    return {
      sku: (_a = serviceCustomLineItem.custom) == null ? void 0 : _a.fields.serviceKey,
      taxRate: serviceCustomLineItem.taxRate,
      basePrice: getBasePrice({
        lineItems: [serviceCustomLineItem]
      }),
      price: getPrice({
        lineItems: [serviceCustomLineItem]
      }),
      discounts: getDiscounts({
        lineItems: [serviceCustomLineItem],
        discountTags
      }),
      quantity: serviceCustomLineItem.quantity,
      serviceName: (_b = serviceCustomLineItem.custom) == null ? void 0 : _b.fields.serviceName
    };
  });
};
var lineItemPrices = _ref23 => {
  let {
    lineItemId,
    cartOrOrder,
    calculateGroup = true,
    discountTags = []
  } = _ref23;
  let lineItems = [];
  const lineItem = getLineItemById({
    lineItemId,
    cartOrOrder
  });
  if (!lineItem) {
    return {};
  }
  if (calculateGroup && isGroupedLineItem(lineItem)) {
    lineItems = getGroupedLineItems({
      lineItemId,
      cartOrOrder
    });
  } else {
    lineItems.push(lineItem);
  }
  if (!lineItems.length) {
    return {};
  }
  return {
    product: calculateProductTotals({
      lineItems,
      discountTags
    }),
    shipping: calculateCustomLineItemsOfType({
      lineItems,
      cartOrOrder,
      discountTags,
      customLineItemType: "shipping"
    }),
    services: calculateServiceTotals({
      lineItems,
      cartOrOrder,
      discountTags
    }),
    additionalAddressCosts: calculateCustomLineItemsOfType({
      lineItems,
      cartOrOrder,
      discountTags,
      customLineItemType: "additional-address-costs"
    }),
    deliveryService: calculateCustomLineItemsOfType({
      lineItems,
      cartOrOrder,
      discountTags,
      customLineItemType: "deliveryService"
    }),
    customerDiscount: calculateCustomLineItemsOfType({
      lineItems,
      cartOrOrder,
      discountTags,
      customLineItemType: "customerDiscount"
    })
  };
};
var calculateDiscount = _ref24 => {
  let {
    totalDiscounts,
    discounts
  } = _ref24;
  if (!discounts) {
    return totalDiscounts;
  }
  const sum = totalDiscounts != null ? totalDiscounts : {};
  Object.keys(discounts).forEach(key => {
    if (!sum[key]) {
      sum[key] = discounts[key];
      return;
    }
    sum[key].totalTax.centAmount += discounts[key].totalTax.centAmount;
    sum[key].totalNet.centAmount += discounts[key].totalNet.centAmount;
    sum[key].totalGross.centAmount += discounts[key].totalGross.centAmount;
  });
  return sum;
};
var calculateTotal = _ref25 => {
  let {
    total,
    current
  } = _ref25;
  if (!total) {
    return current;
  }
  const sum = total;
  sum.totalTax.centAmount += current.totalTax.centAmount;
  sum.totalNet.centAmount += current.totalNet.centAmount;
  sum.totalGross.centAmount += current.totalGross.centAmount;
  return sum;
};
var cartOrOrderTotals = _ref26 => {
  let {
    cartOrOrder,
    calculateGroup = true,
    discountTags = [],
    lineItemIds = []
  } = _ref26;
  let givenLineItemIds = lineItemIds;
  if (!(lineItemIds == null ? void 0 : lineItemIds.length)) {
    givenLineItemIds = getAllMainGroupedLineItems({
      cartOrOrder
    }).map(lineItem => lineItem.id);
  }
  const totals = {
    product: {
      basePrice: void 0,
      price: void 0
    },
    discounts: void 0,
    shipping: {
      basePrice: void 0,
      price: void 0
    },
    additionalAddressCosts: {
      basePrice: void 0,
      price: void 0,
      quantity: 0
    },
    services: {
      basePrice: void 0,
      price: void 0,
      quantity: 0,
      services: {}
    },
    customerDiscount: void 0,
    deliveryService: {
      basePrice: void 0,
      price: void 0,
      quantity: 0
    },
    couponCodes: calculateCouponTotals({
      cartOrOrder
    }),
    totalPrice: {
      taxPortions: cartOrOrder.taxedPrice.taxPortions,
      totalGross: {
        centAmount: cartOrOrder.taxedPrice.totalGross.centAmount,
        currencyCode: cartOrOrder.taxedPrice.totalGross.currencyCode
      },
      totalTax: {
        centAmount: cartOrOrder.taxedPrice.totalTax.centAmount,
        currencyCode: cartOrOrder.taxedPrice.totalTax.currencyCode
      },
      totalNet: {
        centAmount: cartOrOrder.taxedPrice.totalNet.centAmount,
        currencyCode: cartOrOrder.taxedPrice.totalNet.currencyCode
      }
    }
  };
  const lineItemTotals = givenLineItemIds.map(lineItemId => lineItemPrices({
    lineItemId,
    cartOrOrder,
    discountTags,
    calculateGroup
  }));
  const services = /* @__PURE__ */new Map();
  lineItemTotals.filter(total => total).forEach(total => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
    totals.discounts = calculateDiscount({
      totalDiscounts: totals.discounts,
      discounts: ((_a = total.product) == null ? void 0 : _a.discounts) || {}
    });
    totals.product.basePrice = calculateTotal({
      total: (_b = totals.product) == null ? void 0 : _b.basePrice,
      current: total.product.basePrice || {}
    });
    totals.product.price = calculateTotal({
      total: (_c = totals.product) == null ? void 0 : _c.price,
      current: total.product.price || {}
    });
    if (total.shipping) {
      totals.discounts = calculateDiscount({
        totalDiscounts: totals.discounts,
        discounts: ((_d = total.shipping) == null ? void 0 : _d.discounts) || {}
      });
      totals.shipping.basePrice = calculateTotal({
        total: (_e = totals.shipping) == null ? void 0 : _e.basePrice,
        current: total.shipping.basePrice || {}
      });
      totals.shipping.price = calculateTotal({
        total: (_f = totals.shipping) == null ? void 0 : _f.price,
        current: total.shipping.price || {}
      });
    }
    if (total.additionalAddressCosts) {
      totals.discounts = calculateDiscount({
        totalDiscounts: totals.discounts,
        discounts: ((_g = total.additionalAddressCosts) == null ? void 0 : _g.discounts) || {}
      });
      totals.additionalAddressCosts.price = calculateTotal({
        total: (_h = totals.additionalAddressCosts) == null ? void 0 : _h.price,
        current: total.additionalAddressCosts.price
      });
      totals.additionalAddressCosts.basePrice = calculateTotal({
        total: (_i = totals.additionalAddressCosts) == null ? void 0 : _i.basePrice,
        current: total.additionalAddressCosts.basePrice
      });
      totals.additionalAddressCosts.quantity += total.additionalAddressCosts.quantity;
    }
    if (total.customerDiscount) {
      totals.customerDiscount = calculateTotal({
        total: totals.customerDiscount,
        current: total.customerDiscount.price
      });
    }
    if (total.deliveryService) {
      totals.discounts = calculateDiscount({
        totalDiscounts: totals.discounts,
        discounts: ((_j = total.deliveryService) == null ? void 0 : _j.discounts) || {}
      });
      totals.deliveryService.price = calculateTotal({
        total: (_k = totals.deliveryService) == null ? void 0 : _k.price,
        current: total.deliveryService.price
      });
      totals.deliveryService.basePrice = calculateTotal({
        total: (_l = totals.deliveryService) == null ? void 0 : _l.basePrice,
        current: total.deliveryService.basePrice
      });
      totals.deliveryService.quantity += total.deliveryService.quantity;
    }
    (_m = total.services) == null ? void 0 : _m.forEach(service => {
      if (!services.has(service.sku)) {
        services.set(service.sku, service);
      } else {
        const serviceSet = services.get(service.sku);
        const serviceFromSet = (0, import_json2.klona)(serviceSet);
        const newService = __spreadProps(__spreadValues({}, serviceFromSet), {
          quantity: serviceFromSet.quantity + service.quantity,
          price: calculateTotal({
            total: serviceFromSet.price,
            current: service.price
          }),
          basePrice: calculateTotal({
            total: serviceFromSet.basePrice,
            current: service.basePrice
          })
        });
        services.set(service.sku, newService);
      }
      totals.discounts = calculateDiscount({
        totalDiscounts: totals.discounts,
        discounts: service.discounts || {}
      });
      totals.services.price = calculateTotal({
        total: totals.services.price,
        current: service.price
      });
      totals.services.basePrice = calculateTotal({
        total: totals.services.basePrice,
        current: service.basePrice
      });
      totals.services.quantity += total.services.length;
      totals.services.services = Object.fromEntries(services);
    });
  });
  return totals;
};

// src/validators/schemas/Cart.ts
var yup3 = __toESM(require("yup"));
var import_isEmail = __toESM(require("validator/lib/isEmail"));

// src/validators/schemas/PostalCode.ts
var yup = __toESM(require("yup"));
var postalCodeSchema = yup.string().trim().required().when("country", {
  is: value => value.toLowerCase() === "nl",
  then: schema => schema.required().matches(/^[1-9][0-9]{3}\s*?[a-zA-Z]{2}$/),
  otherwise: schema => schema.min(1).matches(/^[0-9a-zA-Z\s-]*$/)
});

// src/validators/schemas/ShippingAddress.ts
var yup2 = __toESM(require("yup"));
var shippingAddressSchema = yup2.object().shape({
  postalCode: postalCodeSchema,
  country: yup2.string().trim().required().length(2),
  streetNumber: yup2.string().trim().required().max(100),
  streetName: yup2.string().trim().required().max(100),
  city: yup2.string().trim().required().max(100),
  firstName: yup2.string().trim().required().max(75).test("arteriskFirstName", "Cannot be an *.", value => value !== "*"),
  lastName: yup2.string().trim().required().max(150).test("arteriskLastName", "Cannot be an *.", value => value !== "*"),
  phone: yup2.string().trim(),
  company: yup2.string().trim().max(255).test("arteriskCompany", "Cannot be an *.", value => value !== "*")
});

// src/validators/schemas/Cart.ts
var cartSchema = yup3.object().shape({
  lineItems: yup3.array().of(yup3.object().shape({
    id: yup3.string(),
    custom: yup3.object().shape({
      fields: yup3.object().shape({
        shippingAddressPerLineItem: yup3.array().when(["isWithPickupLocation"], {
          is: isWithPickupLocation => !isWithPickupLocation,
          then: schema => schema.of(shippingAddressSchema).required()
        })
      }).required()
    }).required()
  })).required(),
  shippingAddress: yup3.object().shape({
    country: yup3.string().trim().required().length(2)
  }).required(),
  billingAddress: yup3.object().shape({
    country: yup3.string().trim().required().length(2),
    postalCode: postalCodeSchema,
    streetNumber: yup3.string().trim().required().max(100),
    streetName: yup3.string().trim().required().max(100),
    city: yup3.string().trim().required().max(100),
    firstName: yup3.string().when(["isCompany", "company", "lastName"], {
      is: (isCompany, company, lastName) => isCompany ? !company && !lastName : true,
      then: schema => schema.trim().max(75).required(),
      otherwise: schema => schema.trim().max(75)
    }),
    lastName: yup3.string().when(["isCompany", "company", "firstName"], {
      is: (isCompany, company, firstName) => isCompany ? !company && !firstName : true,
      then: schema => schema.trim().max(150).required(),
      otherwise: schema => schema.trim().max(150)
    }),
    phone: yup3.string().trim(),
    email: yup3.string().trim().max(255).required().email().test(email => (0, import_isEmail.default)(email, {
      blacklisted_chars: "\xE0\xE8\xEC\xF2\xF9\xC0\xC8\xCC\xD2\xD9\xE1\xE9\xED\xF3\xFA\xFD\xC1\xC9\xCD\xD3\xDA\xDD\xE2\xEA\xEE\xF4\xFB\xC2\xCA\xCE\xD4\xDB\xE3\xF1\xF5\xC3\xD1\xD5\xE4\xEB\xEF\xF6\xFC\xFF\xC4\xCB\xCF\xD6\xDC\u0178\xE7\xC7\xDF\xD8\xF8\xC5\xE5\xC6\xE6\u0153",
      allow_utf8_local_part: false,
      require_tld: true
    })),
    company: yup3.string().when(["isCompany", "firstName", "lastName"], {
      is: (isCompany, firstName, lastName) => isCompany && !firstName && !lastName,
      then: schema => schema.trim().max(255).required(),
      otherwise: schema => schema.trim().max(255)
    })
  }, [["company", "lastName"], ["company", "firstName"], ["firstName", "lastName"]]),
  custom: yup3.object().shape({
    fields: yup3.object().shape({
      isCompany: yup3.bool()
    })
  })
});

// src/validators/Cart.ts
var validateCart = cart => cartSchema.validate(transformCartForValidation(cart), {
  strict: false,
  abortEarly: false,
  stripUnknown: false,
  recursive: true
}).then(() => Promise.resolve("No errors")).catch(error => {
  const rejection = {
    errorMessage: {
      statusCode: 400,
      message: "Invalid cart!",
      errors: error.inner.map(errorField => ({
        path: errorField.path,
        message: errorField.message
      })).filter((value, index, self) => self.indexOf(value) === index)
    }
  };
  return Promise.reject(rejection);
});

// test/builders/CartBuilder.ts
var import_uuid = require("uuid");

// test/mocks/Addresses.ts
var addresses = {
  drukwerkdeal: {
    additionalStreetInfo: "",
    city: "Deventer",
    company: "Drukwerkdeal",
    country: "NL",
    email: "john.williams@drukwerkdeal.nl",
    firstName: "John",
    id: "1337",
    lastName: "Williams",
    phone: "",
    postalCode: "7418ET",
    streetName: "Keulenstraat",
    streetNumber: "4 "
  },
  broodbode: {
    additionalStreetInfo: "",
    city: "Deventer",
    company: "Broodbode",
    country: "NL",
    email: "info@brooooodbode.nl",
    firstName: "Bakker",
    id: "1338",
    lastName: "Bart",
    phone: "",
    postalCode: "7418ET",
    streetName: "Keulenstraat",
    streetNumber: "10 "
  },
  theDonerCompany: {
    additionalStreetInfo: "",
    city: "Amstetrdam",
    company: "The D\xF6ner Company",
    country: "NL",
    email: "doner@company.nl",
    firstName: "John",
    id: "1339",
    lastName: "Doe",
    phone: "0612345678",
    postalCode: "1097DN",
    streetName: "Julianaplein",
    streetNumber: "1 "
  }
};

// test/builders/fixtures/line-items/DefaultLineItem.ts
var address = addresses.drukwerkdeal;
var defaultLineItemFixture = {
  id: "9fadf318-dad2-4c4a-ba8a-d85537b144af",
  productId: "853f36f2-8e15-4cda-98cf-fdf3347d4b9d",
  productKey: "PRD-SVX1FPID",
  name: {
    en: "Flyers",
    nl: "Flyers"
  },
  productType: {
    typeId: "product-type",
    id: "b9808fea-32d9-4946-aeef-7fabde7ed6c1"
  },
  productSlug: {
    en: "flyers-1557390617467"
  },
  variant: {
    // Normally this is a variant object, but for the interface we only need the id
    id: 10
  },
  price: {
    id: "ed6b1c69-a17a-4513-8653-b23da5ef4aef",
    value: {
      type: "highPrecision",
      currencyCode: "EUR",
      centAmount: 4,
      preciseAmount: 387800,
      fractionDigits: 7
    }
  },
  quantity: 1e3,
  discountedPricePerQuantity: [],
  taxRate: {
    name: "ATax",
    amount: 0.21,
    includedInPrice: false,
    country: "NL",
    subRates: []
  },
  perMethodTaxRate: [],
  addedAt: "2022-12-13T10:59:59.997Z",
  lastModifiedAt: "2022-12-13T10:59:59.997Z",
  state: [{
    quantity: 1e3,
    state: {
      typeId: "state",
      id: "8c982122-f1e9-4e57-9a1f-a6698835e876"
    }
  }],
  priceMode: "ExternalPrice",
  lineItemMode: "Standard",
  totalPrice: {
    type: "centPrecision",
    currencyCode: "EUR",
    centAmount: 3878,
    fractionDigits: 2
  },
  taxedPrice: {
    totalNet: {
      type: "centPrecision",
      currencyCode: "EUR",
      centAmount: 3878,
      fractionDigits: 2
    },
    totalGross: {
      type: "centPrecision",
      currencyCode: "EUR",
      centAmount: 4692,
      fractionDigits: 2
    },
    totalTax: {
      type: "centPrecision",
      currencyCode: "EUR",
      centAmount: 814,
      fractionDigits: 2
    },
    taxPortions: []
  },
  taxedPricePortions: [],
  custom: {
    type: {
      typeId: "type",
      id: "123d104b-501e-46ac-9539-de5c04dd93c4"
    },
    fields: {
      mcpProductName: "Flyers",
      isSplitShipping: false,
      artworkRequired: "yes",
      merchandisingProductName: "Flyers",
      bufferArtworkServiceHours: "0",
      isSkuTranslationRequired: true,
      productDescription: {
        nl: "Formaat: A5 (148 x 210 mm), Breedte: 14.8, Hoogte: 21, Bedrukking: 4/4 (Dubbelzijdig full color), Materiaal: Houtvrij gesatineerd mc  (glanzend), Gewicht: 170 g/m\xB2, Afwerking: Geen afwerking, Druktechniek: Full color offset, Levertijd: Normale levering"
      },
      editorType: "checkmate",
      contentfulPageId: "6M3pZ8ippuasAYcemeWy2a",
      userSelection: ["Format:A5", "Custom width:14.8", "Custom height:21", "Printing Colors:4/4 Full Color", "Material:Woodfree Coated Glossy Mc", "Weight:170 Grs", "Finishing:Without Luxury Finishing", "Punchholes:No Punchhole", "Bundling:No Bundling", "Printing Process:Offset", "Delivery Type:Normal"],
      promisedArrivalDate: "2022-12-19",
      networkSku: "CIM-VPEJQPJ8",
      merchandisingProductCategory: "Promotie",
      finalSelection: ["Format:A5", "Custom width:14.8", "Custom height:21", "Printing Colors:4/4 Full Color", "Material:Woodfree Coated Glossy Mc", "Weight:170 Grs", "Printing Process:Offset", "Punchholes:No Punchhole", "Bundling:No Bundling", "Finishing:Without Luxury Finishing", "Curved Corners:Square Corners", "Delivery Type:Normal", "Number of Designs:1 Design", "Quantity:1000", "Aspect Ratio:0.7047619", "Production Time Increase - Punchholes or Bundling:0", "Production Time Increase - Material:0", "Production Time:3", "Surface Bleed:3", "Sets:1", "Orientation:Portrait", "Creasing:None", "Folding Method:None", "Designs:1", "Prepress URL:https://print.prepress.cimpress.io/v2/print-prep?asynchronous=true", "Prepress Parameters URL:https://readonly.uploads.documents.cimpress.io/v1/uploads/7d120787-92e7-4e5c-b10d-7b823b625b41~100?tenant=prepress-uploads", "Perforating:No Perforationline", "Checkmate:On", "Artwork Required:Yes", "Surface Safety:0", "Fulfillment Configuration:https://fulfillmentscenarios.fi.cimpress.io/v1/scenarios:echo?fulfillerIds=yy48m4r8x5&fulfillmentLocationIds=yzmeyyz6", "Surface Coating Type Side 1:None", "Surface Coating Finish Side 1:None", "Surface Coating Type Side 2:None", "Surface Coating Finish Side 2:None", "Lamination Feature Side 1:None", "Lamination Feature Side 2:None", "Special Finishing Color Side 1:None", "Special Finishing Color Side 2:None", "Secondary Folding Style:None", "Folding Panel 1 Width:0", "Folding Panel 1 Height:0", "Folding Panel 2 Width:0", "Folding Panel 2 Height:0", "Folding Panel 3 Width:0", "Folding Panel 3 Height:0", "Folding Panel 4 Width:0", "Folding Panel 4 Height:0", "Folding Panel 5 Width:0", "Folding Panel 5 Height:0", "Folding Panel 6 Width:0", "Folding Panel 6 Height:0", "Folding Panel 7 Width:0", "Folding Panel 7 Height:0", "Folding Panel 8 Width:0", "Folding Panel 8 Height:0", "Outer Pack:Box", "Substrate Name:Undefined", "Substrate Brand:Undefined", "Substrate Color:White", "Substrate Thickness:10", "Cut Shape Type:Rectangle", "Route Only:Yes", "Perforation Lines:None", "Scent:None", "Number of Secondary Folds:0", "Available Spot Colors URL Side 1:Undefined", "Available Spot Colors URL Side 2:Undefined", "Production Time Type:dd", "Production Delay URL:Undefined", "Shippable Pack Quantity:1", "Shippable Pack Weight:0", "Shippable Pack Dimension 1:0", "Shippable Pack Dimension 2:0", "Shippable Pack Dimension 3:0", "Split Shipment Allowed:Yes", "Split Shipment Salesprice:10.33", "Split Shipment Currency Code:EUR", "InventoryCheck:No", "Folded Width:14.8", "Folded Height:21", "Process Color Side 1:CMYK", "Process Color Side 2:CMYK", "Spot Color Count Side 1:0", "Spot Color Count Side 2:0", "Substrate Type:Paper", "Substrate Coating:C1S", "Substrate Finish:Gloss/Semi-gloss", "Substrate Weight:170", "Number Of Holes For Filing:0", "Inner Pack:Undefined", "Production Time Increase - Finishing:0", "Lamination Type Side 1:None", "Lamination Type Side 2:None", "Special Finishing Type Side 1:None", "Special Finishing Type Side 2:None", "Corner Finishing Type:Squared", "Corner Finishing Radius:0", "Primary Folding Style:None", "Number of Primary Folds:0", "Number of Sides:2", "Ships Folded:No", "Trim Height:21", "Trim Width:14.8", "Finishing Method Cutting Type:Through Cut"],
      originalLineItemAmount: {
        type: "centPrecision",
        currencyCode: "EUR",
        centAmount: 3878,
        fractionDigits: 2
      },
      bufferProductionHours: "0",
      isReverseRateApplied: false,
      mcpProductionHours: "72",
      configurationURL: "https://cdn-configuration.products.cimpress.io/v1/configurations/faa4eee9c165b11784716cf54b4a2ba39e5257cd",
      productKey: "PRD-SVX1FPID",
      discountedProductPriceValue: {
        type: "centPrecision",
        currencyCode: "EUR",
        centAmount: 3878,
        fractionDigits: 2
      },
      mcpSku: "CIM-8DRCUBX8",
      merchProductURL: "https://drukwerkdeal.nl/nl/producten/promotie/flyers?selection=bundling%3Dno%2520bundling%26custom%2520height%3D21%26custom%2520width%3D14.8%26delivery%2520type%3Dnormal%26finishing%3Dwithout%2520luxury%2520finishing%26format%3Da5%26material%3Dwoodfree%2520coated%2520glossy%2520mc%26printing%2520colors%3D4%252F4%2520full%2520color%26printing%2520process%3Doffset%26punchholes%3Dno%2520punchhole%26quantity%3D1000%26weight%3D170%2520grs",
      localizedProductName: {
        nl: "Flyers (ongevouwen)"
      },
      originalLineItemAmountWithTax: {
        type: "centPrecision",
        currencyCode: "EUR",
        centAmount: 3878,
        fractionDigits: 2
      },
      variableAttributes: ["Format:A5", "Custom width:14.8", "Custom height:21", "Printing Colors:4/4 Full Color", "Material:Woodfree Coated Glossy Mc", "Weight:170 Grs", "Printing Process:Offset", "Punchholes:No Punchhole", "Bundling:No Bundling", "Finishing:Without Luxury Finishing", "Curved Corners:Square Corners", "Delivery Type:Normal", "Number of Designs:1 Design", "Quantity:1000"],
      shippingAddressPerLineItem: [["firstName:".concat(address.firstName), "lastName:".concat(address.lastName), "streetName:".concat(address.streetName), "streetNumber:".concat(address.streetNumber), "additionalStreetInfo:".concat(address.additionalStreetInfo), "postalCode:".concat(address.postalCode), "city:".concat(address.city), "country:".concat(address.country), "company:".concat(address.company), "phone:".concat(address.phone), "email:".concat(address.email), "id:".concat(address.id)]],
      baseProductPriceValue: {
        type: "centPrecision",
        currencyCode: "EUR",
        centAmount: 3878,
        fractionDigits: 2
      }
    }
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AddLineItemHelper,
  CartChangeAfterLogin,
  calculateCustomLineItemsOfType,
  calculateProductTotals,
  cartOrOrderTotals,
  filterRemainingOption,
  getAllMainGroupedLineItems,
  getBasePrice,
  getCartChangeAfterLogin,
  getCustomLineItemsOfType,
  getDeliveryOptionId,
  getDiscounts,
  getGroupId,
  getGroupedLineItems,
  getLastUpdatedPayment,
  getLineItemById,
  getLineItemGroupType,
  getLineItemQuantity,
  getLineItemReviewGroup,
  getLineItemsInReviewGroup,
  getLineItemsIncludingGroupSiblings,
  getMainLineItems,
  getMultipleDesignsGroupLineItems,
  getOrchestrationLineItems,
  getPrice,
  getReviewGroupLineItems,
  getVisibleCartChangeAfterLogin,
  hasLineItemReviewGroup,
  isAddressOnCartComplete,
  isBillingAddressCountryValidOnCart,
  isBillingAddressValidOnCart,
  isCart,
  isGroupedLineItem,
  isLineItemReviewGroupLead,
  isOrder,
  isShippingAddressCountryValidOnCart,
  isShippingAddressValidOnCart,
  lineItemPrices,
  shouldRemoveArtwork,
  transformCartForValidation,
  validateCart
});